import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-gray-900 text-white" data-id="element-136">
      <div className="container mx-auto px-4 py-12" data-id="element-137">
        <div className="flex flex-col md:flex-row justify-between mb-8" data-id="element-138">
          <div className="mb-6 md:mb-0" data-id="element-139">
            <img src="https://professorpressurewashing.com/wp-content/uploads/2025/01/IMG_8776-removebg-preview-e1741153166170.png" alt="Professor Pressure Washing Logo" className="h-16 mb-4" data-id="element-140" />
            <p className="text-gray-400 max-w-sm" data-id="element-141">
              Professional pressure washing services for residential and
              commercial properties. We take pride in our work and guarantee
              customer satisfaction.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8" data-id="element-142">
            <div data-id="element-143">
              <h3 className="text-lg font-semibold mb-4" data-id="element-144">Quick Links</h3>
              <ul className="space-y-2" data-id="element-145">
                <li data-id="element-146">
                  <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-147">
                    Services
                  </a>
                </li>
                <li data-id="element-148">
                  <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-149">
                    About Us
                  </a>
                </li>
                <li data-id="element-150">
                  <a href="#testimonials" className="text-gray-400 hover:text-white transition-colors" data-id="element-151">
                    Testimonials
                  </a>
                </li>
                <li data-id="element-152">
                  <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-153">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-154">
              <h3 className="text-lg font-semibold mb-4" data-id="element-155">Services</h3>
              <ul className="space-y-2" data-id="element-156">
                <li data-id="element-157">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-158">
                    Residential
                  </a>
                </li>
                <li data-id="element-159">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-160">
                    Commercial
                  </a>
                </li>
                <li data-id="element-161">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-162">
                    Soft Washing
                  </a>
                </li>
                <li data-id="element-163">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-164">
                    Surface Sealing
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-165">
              <h3 className="text-lg font-semibold mb-4" data-id="element-166">Contact</h3>
              <ul className="space-y-2" data-id="element-167">
                <li className="text-gray-400" data-id="element-168">980 500 9213</li>
                <li className="text-gray-400" data-id="element-169">
                  professor.pressure.washing.nc@gmail.com
                </li>
              </ul>
              <div className="flex space-x-4 mt-4" data-id="element-170">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-171">
                  <FacebookIcon size={20} data-id="element-172" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-173">
                  <InstagramIcon size={20} data-id="element-174" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-175">
                  <TwitterIcon size={20} data-id="element-176" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-800 text-center" data-id="element-177">
          <p className="text-gray-500" data-id="element-178">
            &copy; {new Date().getFullYear()} Professor Pressure Washing. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};